import { AleitamentoMaterno, Antecedente, AtendimentoPuericultura, MChatRiscoEnum } from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'

import { MchatRfAplicacaoQueryModel, MChatRfViewModel } from '../../objetivo/puericultura/mchat-rf/model-mChatRf'
import {
  AvaliacaoDesenvolvimentoModel,
  MedicaoAnteriorPuericulturaModel,
  PuericulturaModel,
} from '../../objetivo/puericultura/model'

export type MedicaoAnteriorAcompanhamentoPuericultura = MedicaoAnteriorPuericulturaModel
export type RegistroMChatAcompanhamentoPuericultura = {
  id: ID
  pontuacao: number
  risco: MChatRiscoEnum
  isMchatRf: boolean
  dataResultado: LocalDate
  aplicacao: ReadonlyArray<MchatRfAplicacaoQueryModel>
  atendimentoProfissional: {
    id: ID
    lotacao: {
      id: ID
      profissional: {
        id: ID
        nome: string
        nomeSocial?: string | null
      }
      cbo: { id: ID; nome: string }
    }
  }
}

export const ACOMPANHAMENTO_CRIANCA_URL_MODAL = '/acompanhamento-crianca'

export interface AcompanhamentoPuericulturaModel
  extends Omit<PuericulturaModel, 'hasPuericultura' | 'prenatal' | 'tipoAleitamento' | 'mChatRf'> {
  ultimoAtendimentoPuericultura: AtendimentoPuericultura
  tipoAleitamentoMaterno: AleitamentoMaterno
  preNatalPartoNascimento?: Antecedente
  vacinacaoEmDia: MedicaoAnteriorAcompanhamentoPuericultura
  registrosMChat: ReadonlyArray<RegistroMChatAcompanhamentoPuericultura> | undefined
  mChatRf: MChatRfViewModel
}

export const acompanhamentoPuericulturaFieldName = metaPath<{
  acompanhamentoPuericultura: AcompanhamentoPuericulturaModel
}>()

export const initialValueAvaliacaoAcompanhamento = (
  avaliacao: ReadonlyArray<AvaliacaoDesenvolvimentoModel>
): ReadonlyArray<AvaliacaoDesenvolvimentoModel> =>
  avaliacao
    .map<AvaliacaoDesenvolvimentoModel>((item) => ({ ...item, statusButton: item.status }))
    .sort((a, b) => Number(a.id) - Number(b.id))
